import { render, staticRenderFns } from "./TalkComponent.vue?vue&type=template&id=574b7218&scoped=true"
import script from "./TalkComponent.vue?vue&type=script&lang=js"
export * from "./TalkComponent.vue?vue&type=script&lang=js"
import style0 from "./TalkComponent.vue?vue&type=style&index=0&id=574b7218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574b7218",
  null
  
)

export default component.exports